import { useTranslation } from "react-i18next";
import { Calendar } from "lucide-react";
import { Label } from "../ui/label";
import { DatePicker } from "../ui/DatePicker";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

const EmployeeDatesSection = ({ formData, updateField }) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-4">
      <h3 className="font-medium flex items-center space-x-2">
        <Calendar className="h-4 w-4" />
        <span>{t("employeesPage.sections.importantDates")}</span>
      </h3>
      <div className="grid grid-cols-3 gap-4">
        <div className="space-y-2">
          <Label htmlFor="date_embauche">{t("employeesPage.labels.hireDate")} *</Label>
          <DatePicker value={formData.hire_date} onChange={(v) => updateField("hire_date", v)} />
        </div>
        <div className="space-y-2">
          <Label htmlFor="contract_end_date">{t("employeesPage.labels.contractEndDate")}</Label>
          <DatePicker value={formData.contract_end_date} onChange={(v) => updateField("contract_end_date", v)} />
        </div>
        <div className="space-y-2">
          <Label htmlFor="statut">{t("employeesPage.labels.status")}</Label>
          <Select value={formData.status} onValueChange={(v) => updateField("status", v)}>
            <SelectTrigger><SelectValue placeholder={t("employeesPage.placeholders.status")} /></SelectTrigger>
            <SelectContent>
              <SelectItem value="ACTIVE">{t("employeesPage.status.active")}</SelectItem>
              <SelectItem value="INACTIVE">{t("employeesPage.status.inactive")}</SelectItem>
              <SelectItem value="SUSPENDED">{t("employeesPage.status.suspended")}</SelectItem>
              <SelectItem value="ARCHIVED">{t("employeesPage.status.archived")}</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
};

export default EmployeeDatesSection;
